
export class SampleInfo{
	constructor(        

        public project_ID?: string,
        public template_ID?: string,
        public curStage?: string,
        public curStageStr?: string,
        public curOrderNO?: string,
        public curSampleNO?: string,

        public curPicSrc?: string,
        public curPicName?: string,
		public pic1Src?: string,
		public pic2Src?: string,
		public pic3Src?: string,
        public pic1Name?: string,
        public pic2Name?: string,
        public pic3Name?: string,
        public resultReal?: string,
        public resultReal_P?: string,
        public resultReal_C?: string,
        public resultReal_P_T?: string,
        public resultReal_C_T?: string,
        public resultCompare?: string,
        public resultCompare_P?: string,
        public resultCompare_P_T?: string,
        public resultCompare_C?:string,
        public resultCompare_C_T?:string,
        public resultCompare_PR3?:string,
        public resultCompare_PR3_T?:string,
        public resultCompare_MPO?:string,
        public resultCompare_MPO_T?:string,
        public resultCompare_Remark?:string,
        public resultCompare_D?:string,
        public diduMoto?:[],
        public sampleList?:[],
        public allCount?: string,
        public answerCount?: string,
        public orderNOForSave?: string,
        public sampleNOForSave?: string,
        public opFlag?: string,
        public doneOrder?: string,
        ){}
	
}